import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { IntelligenceDiagram } from './IntelligenceDiagram';
import { demoCenterPath } from '../../data/demoCenter';
import { easeOutStrong } from '../../utils/motion';
export function HomeHero() {
  return <section className="bg-white border-b border-line pt-32 pb-20 lg:pt-44 lg:pb-28" data-id="element-1159" data-mp="294arynz6wti2">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-10 items-center" data-id="element-1160" data-mp="2wu4y6mp07jtc">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: easeOutStrong
      }} className="lg:col-span-7" data-id="element-1161" data-mp="31thnrf79f4zm">
          <h1 className="font-heading font-extrabold text-5xl sm:text-6xl lg:text-7xl text-ink-dark leading-[1.03] tracking-tight" data-id="element-1162" data-mp="2s2d9khpero5u">
            Connected knowledge. Human capability. Intelligent action.
          </h1>
          <p className="mt-8 text-xl lg:text-2xl text-ink-dark/80 leading-relaxed max-w-2xl" data-id="element-1163" data-mp="3klaet42rqg4p">
            SyNeural develops systems that help institutions organize
            knowledge, understand capabilities and turn evidence into
            practical action.
          </p>
          <p className="mt-5 text-lg text-ink-muted leading-relaxed max-w-2xl" data-id="element-1164" data-mp="xokmjj4wkc3i">
            Our Semantic Knowledge Platform connects and governs information.
            Our Human Capability Framework structures assessment and
            development. Noetivra brings them together in an intuitive
            workspace for exploration, review, coordination and
            decision-making.
          </p>
          <p className="mt-4 text-lg text-ink-muted leading-relaxed max-w-2xl" data-id="element-1165" data-mp="1gl3qlu0un9t7">
            Built for research institutions, businesses and governments,
            SyNeural connects what an organization knows with what its people
            can do—and how both can improve.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-4" data-id="element-1166" data-mp="3ed81dd3v7ht6">
            <a href="/solutions" className="inline-flex items-center justify-center gap-2 bg-navy hover:bg-navy-light text-white font-medium px-6 py-3.5 rounded-md transition-colors duration-150 shadow-sm whitespace-nowrap" data-id="element-1167" data-mp="1hbsdr55qiy6x">
              Explore Our Solutions
              <ArrowRight size={18} aria-hidden="true" data-id="element-1168" data-mp="1w8jhfqmfyw2c" />
            </a>
            <a href={demoCenterPath} className="inline-flex items-center justify-center gap-2 border border-navy text-navy hover:bg-surface-muted font-medium px-6 py-3.5 rounded-md transition-colors duration-150 whitespace-nowrap" data-id="element-1169" data-mp="1w6q7o2gj7vq4">
              Open Noetivra Demo
              <ArrowRight size={18} aria-hidden="true" data-id="element-1170" data-mp="2a2k77uvf18qk" />
            </a>
          </div>
        </motion.div>

        <div className="lg:col-span-5" data-id="element-1171" data-mp="2jydt44v0yel0">
          <IntelligenceDiagram data-id="element-1172" data-mp="2jzf2m4we6t0m" />
        </div>
      </div>
    </section>;
}